import { render, staticRenderFns } from "./multiRoam.vue?vue&type=template&id=a2ddceb0&"
import script from "./multiRoam.vue?vue&type=script&lang=js&"
export * from "./multiRoam.vue?vue&type=script&lang=js&"
import style0 from "./multiRoam.vue?vue&type=style&index=0&id=a2ddceb0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports